import React from "react"
import jump from "jump.js"

import { getUrlParams } from "../../../helpers/params"
import { setCookie, getCookie } from "../../../helpers/cookie"

import Commision from "../../../images/cashNow/icons/commision.png"
import Insurance from "../../../images/cashNow/icons/insurance.png"
import Home from "../../../images/cashNow/icons/home.png"
import Procent from "../../../images/cashNow/icons/procent.png"

// import Cash from '../../../images/cashNow/cash.png';
// import Cash from '../../../images/cashNow/rozhok_dengi_min.png';
import Cash from "../../../images/cashNow/groshi.png"

import "./index.scss"

const jumpToCalc = () => {
  document.querySelector(".cashnowatm--calculator").scrollIntoView({
    behavior: "smooth",
  })
}

const jumpToOrder = () => {
  document.querySelector(".cashnowatm--order").scrollIntoView({
    behavior: "smooth",
  })
}

const Main = () => {
  const { aff_sub, aff_id, click_id, admitad_uid } = getUrlParams()
  const userCookieSub = getCookie("CLICK_ID")
  const userCookieId = getCookie("AID")
  const userAdmitadId = getCookie("admitad_uid")

  if (userCookieSub) {
    if (userCookieSub === click_id) {
      setCookie("CLICK_ID", click_id, 30)
    } else {
      if (click_id) {
        setCookie("CLICK_ID", click_id, 30)
      }
    }
  } else {
    if (click_id) {
      setCookie("CLICK_ID", click_id, 30)
    }
  }

  if (userCookieId) {
    if (userCookieId === aff_id) {
      setCookie("AID", aff_id, 30)
    } else {
      if (aff_id) {
        setCookie("AID", aff_id, 30)
      }
    }
  } else {
    if (aff_id) {
      setCookie("AID", aff_id, 30)
    }
  }

  if (userAdmitadId) {
    if (userAdmitadId === admitad_uid) {
      setCookie("admitad_uid", admitad_uid, 30)
    } else {
      if (admitad_uid) {
        setCookie("admitad_uid", admitad_uid, 30)
      }
    }
  } else {
    if (admitad_uid) {
      setCookie("admitad_uid", admitad_uid, 30)
    }
  }

  return (
    <div className="cashnowatm--main">
      <div className="cashnowatm--main__wrapper">
        <div className="cashnowatm--main__image">
          <img src={Cash} style={{ maxWidth: "480px" }} />
        </div>
        <div className="cashnowatm--main__content">
          <div className="cashnowatm--main__content-header">
            КРЕДИТИ ГОТІВКОЮ
            <br />
            НА БУДЬ-ЯКІ ПОТРЕБИ
          </div>
          <div className="cashnowatm--main__content-subheader">
            НА СУМУ ДО 1 000 000 ГРН
          </div>
          <div className="cashnowatm--main__content-items">
            {/*<div className="cashnowatm--main__content-item">
                            <img src={Commision} />
                            ЩОМІСЯЧНА КОМІСІЯ – 2,9% 
                        </div>*/}
            <div className="cashnowatm--main__content-item">
              <img src={Insurance} />
              БЕЗ СТРАХУВАННЯ
            </div>
            <div className="cashnowatm--main__content-item">
              <img src={Home} />
              БЕЗ ЗАСТАВ ТА ПОРУЧИТЕЛІВ
            </div>
            <div className="cashnowatm--main__content-item">
              <img src={Procent} />
              Без будь-яких комісій
            </div>
          </div>
          <div className="cashnowatm--main__content-controls">
            <button
              className="cashnowatm--main__btn"
              onClick={() => jumpToOrder()}
            >
              Подати заявку
            </button>
            {/*<button className="cashnowatm--main__btn" onClick={() => jumpToCalc()}>Розрахувати кредит</button>*/}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main
